import { Container, ContainerProps } from "@mui/material"
import React from "react"
import { useIsMobile, useIsLaptop } from "src/hooks/useIsMobile"

const PageContainer = ({ children, sx, ...props }: ContainerProps) => {
  const isMobile = useIsMobile()
  const isLaptop = useIsLaptop()
  const topBarHeight = isMobile ? "58px" : isLaptop ? "66px" : "82px"
  const footerHeight = isLaptop ? "234px" : "80px"
  return (
    <Container
      sx={{
        minHeight: `calc(100vh - ${topBarHeight} - ${footerHeight})`,
        ...sx,
      }}
      {...props}
    >
      {children}
    </Container>
  )
}

export default PageContainer
